<template>
  <div>
    <KTCodePreview :title="titlePage">
      <template v-slot:toolbar>
        <b-dropdown @click="showModal" size="sm" right split variant="primary">
          <template v-slot:button-content>
            <div class="font-weight-bolder">
              <span>
                <i class="flaticon2-add-1 icon-font-size"></i>Tạo mới</span
              >
            </div>
          </template>
        </b-dropdown>
      </template>
      <template v-slot:preview>
        <b-row class="mb-5">
          <b-col cols="3">
            <b-form-group>
              <b-input
                size="sm"
                placeholder="Nhập tên đối tác"
                v-model="apiParams.partnerName"
                v-on:keyup.enter="onFilter()"
              ></b-input>
            </b-form-group>
          </b-col>
          <b-col cols="3">
            <b-form-group>
              <b-input
                size="sm"
                placeholder="Nhập mã đối tác"
                v-model="apiParams.partnerCode"
                v-on:keyup.enter="onFilter()"
              ></b-input>
            </b-form-group>
          </b-col>
          <b-col cols="3">
            <b-form-group>
              <b-input
                size="sm"
                placeholder="Nhập Api Key"
                v-model="apiParams.apiKey"
                v-on:keyup.enter="onFilter()"
              ></b-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mb-5">
          <b-col>
            <b-button
              style="font-weight: 600; width: 70px"
              variant="primary"
              size="sm"
              @click="onFilter"
              >Lọc
            </b-button>
          </b-col>
        </b-row>

        <b-table :items="items" :fields="fields" bordered hover>
          <template #cell(status)="row">
            <b-badge :variant="row.item.status ? `success` : `danger`"
              >{{ row.item.status ? 'Đang hoạt động' : 'Đã khóa' }}
            </b-badge>
          </template>
          <template #cell(user)="row">
            <label>{{ row.item.user.employee.fullName }}</label>
          </template>
          <template #cell(actions)="row">
            <b-dropdown size="sm" id="dropdown-left" no-caret right>
              <template slot="button-content">
                <i class="flaticon2-settings function-btn"></i>
              </template>
              <b-dropdown-item @click="showModal(row.item.id)">
                <span style="color: #3f4254; font-size: 12px">
                  <i style="font-size: 1rem" class="flaticon2-pen"></i>
                  &nbsp; Chỉnh sửa
                </span>
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
      </template>
    </KTCodePreview>
    <UpsertApiKeyModal :id="id" v-on:closeModal="handleCloseModal" />
  </div>
</template>
<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import ApiService from '@/core/services/api.service';
import { SearchApiKeyDto } from '@/view/pages/api-keys/models';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import { DP_CONFIG } from '@/utils/date';
import { TABLE_FIELDS } from '@/view/pages/api-keys/utils/constants';
import UpsertApiKeyModal from '@/view/pages/api-keys/UpsertApiKeyModal.vue';
import { cleanEmptyParams } from '@/utils/common';

export default {
  components: { UpsertApiKeyModal, KTCodePreview },
  data() {
    return {
      id: null,
      titlePage: 'Danh sách API Key đối tác',
      dpConfig: DP_CONFIG.date,
      items: [],
      fields: TABLE_FIELDS,
      apiParams: new SearchApiKeyDto({}),
      userOptions: [],
    };
  },
  methods: {
    onFilter() {
      this.$route.query.page = 1;
      this.$router.push({
        name: 'api-key-list',
      });
      this.fetchData();
    },
    showModal(apiKeyId) {
      this.$bvModal.show('modal-upsert-api-key');
      if (isNaN(Number(apiKeyId))) {
        this.id = null;
        return;
      }
      this.id = apiKeyId;
    },
    handleCloseModal() {
      this.id = null;
      this.fetchData();
    },
    fetchData: function () {
      const cleanParams = cleanEmptyParams(this.apiParams);
      
      ApiService.query('api-keys', {
        params: cleanParams,
      }).then((response) => {
        if (response.data.status) {
          this.items = response.data.data.result;
        }
      });
    },
  },
  created() {
    this.fetchData();
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.titlePage, route: '/api-keys' },
    ]);
  },
};
</script>
<style scoped></style>
